import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { gradientScaleCss, temperatureColorScale } from 'utils/colors/colorScale.utils';
import { imageToIcon } from 'utils/devices/icon.utils';
import { toFiniteNumber } from 'utils/math/math.utils';
import { BuoyConditionsIcon } from '../components/BuoyConditionsIcon/BuoyConditionsIcon';

export const BUOY_TEMPERATURE_DOMAIN = temperatureColorScale.domain();
export const BUOY_NO_TEMPERATURE_COLOR = '#ffffff';

export const buoyTemperatureColorScale = temperatureColorScale;

export const buoyTemperatureGradient = gradientScaleCss(temperatureColorScale);

const getLatestBuoyReading = (device) => {
  if (!Array.isArray(device?.data) || device.data.length === 0) return null;
  return device.data[0] ?? null;
};

export const getBuoyMarkerTemperature = (device) => {
  const latestReading = getLatestBuoyReading(device);
  if (!latestReading) return null;

  return (
    toFiniteNumber(latestReading.air_temperature) ?? toFiniteNumber(latestReading.water_temperature)
  );
};

export const getBuoyMarkerColor = (device) => {
  const temperature = getBuoyMarkerTemperature(device);
  return temperature == null ? BUOY_NO_TEMPERATURE_COLOR : buoyTemperatureColorScale(temperature);
};

export const getBuoyLeafletIcon = (device, size = [30, 30]) => {
  const resolvedSize = Array.isArray(size) ? size : [size, size];
  const svgMarkup = renderToStaticMarkup(
    React.createElement(BuoyConditionsIcon, {
      color: getBuoyMarkerColor(device),
      stroke: '#0B1220',
      strokeWidth: 2,
      borderStroke: '#000000',
      borderStrokeWidth: 4,
      size: resolvedSize[0] || 35,
    }),
  );

  return imageToIcon(`data:image/svg+xml;utf8,${encodeURIComponent(svgMarkup)}`, resolvedSize);
};
